if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.start = Date.parse(this.dataset.start);
      this.end = Date.parse(this.dataset.end);
      this.refresh = () => this.update();
      this.update();
      if (!this.hidden) this.interval = setInterval(this.refresh, 1000);
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.refresh);
    }
    update() {
      const now = Date.now();
      if (!Number.isFinite(this.start) || !Number.isFinite(this.end) || this.end <= this.start || now >= this.end) {
        this.hidden = true;
        clearInterval(this.interval);
        return;
      }
      const before = now < this.start;
      const remaining = Math.max(0, Math.ceil(((before ? this.start : this.end) - now) / 1000));
      const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
      const phase = before ? this.dataset.before : this.dataset.during;
      const label = this.querySelector('[data-phase]');
      if (label.textContent !== phase) label.textContent = phase;
      for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0');
      this.querySelector('[data-fallback]').hidden = true;
      this.querySelector('[data-timer]').hidden = false;
      this.hidden = false;
    }
  });
}
